import { render, staticRenderFns } from "./GamesCarouselItem.vue?vue&type=template&id=191eedd0&scoped=true&"
import script from "./GamesCarouselItem.vue?vue&type=script&lang=js&"
export * from "./GamesCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./GamesCarouselItem.vue?vue&type=style&index=0&id=191eedd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191eedd0",
  null
  
)

export default component.exports